// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";
import normalizeBaseResult from "../helpers/baseResult";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

const withEmployeeName = (form) => {
  const payload = { ...(form || {}) };
  const fullName = String(
    payload.fullname ||
      [payload.name, payload.surname].filter(Boolean).join(" ")
  ).trim();
  const [name = "", ...surnameParts] = fullName.split(/\s+/).filter(Boolean);
  delete payload.fullname;
  return {
    ...payload,
    name,
    surname: surnameParts.join(" "),
  };
};

// ## Employee Get
/**
 *
 * @param {{params: object, query: { searchKey: string, regionId: string, companyId: string, page: number, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Employee.GetAll(option));

  const version = localStorage.getItem("version");

  if (version === "v1" && response.message === "OK") {
    response.data.items = response.data.items.map((item) => ({
      ...item,
      fullname: item.name + " " + item.surname,
    }));
  }

  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Employee Create
/**
 *
 * @param {{ fullname: string, phoneNo: string, email: string, regionId: string, image: File, workStartTime: number, workFinishTime: number, notificationSchedule: object }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(
    Endpoints.Employee.Create(),
    withEmployeeName(form)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Employee Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Employee.GetById(option));

  const version = localStorage.getItem("version");

  if (version === "v1" && response.message === "OK") {
    const data = response.data || null;
    if (data)
      response.data = {
        ...response.data,
        fullname: response.data.name + " " + response.data.surname,
      };
  }

  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Employee Update
/**
 *
 * @param {{ fullname: string, phoneNo: string, email: string, regionId: string, image: File, workStartTime: number, workFinishTime: number, notificationSchedule: object, isActive?: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.Employee.Update(option),
    withEmployeeName(form)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Yalnızca çalışanın haftalık bildirim uygunluk takvimini günceller.
 * @param {object} notificationSchedule Monday-Sunday anahtarlarını içeren tam takvim.
 * @param {{params: { id: string }}} option
 */
export const UpdateNotificationSchedule = async (
  notificationSchedule,
  option
) => {
  const response = await $api.put(
    Endpoints.Employee.UpdateNotificationSchedule(option),
    { notificationSchedule }
  );
  const result = normalizeBaseResult(response);
  return {
    ...result,
    message: result.isSuccess ? "OK" : result.message || "FAIL",
  };
};

// ## Employee Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Employee.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Employee Register With Password
/**
 *
 * @param {{ token: string, password: string }} form
 
 * @returns
 */
export const RegisterWithPassword = async (form) => {
  const response = await $api.post(Endpoints.Employee.RegisterWithPassword(), {
    token: form.token,
    password: form.password,
  });
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Çalışan saha uygulaması girişi (telefon + şifre).
 * @param {{ username: string, password: string }} form
 */
export const Login = async (form) => {
  $api.token = "";
  const response = await $api.post(Endpoints.Employee.Login(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  const token = checker.data?.token ?? checker.token;
  if (checker.message === "OK" && token) $api.token = token;
  return checker;
};

export const ResetPassword = async (form) => {
  const response = await $api.post(Endpoints.Employee.ResetPassword(), {
    token: form.token,
    password: form.password,
  });
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  UpdateNotificationSchedule,
  Delete,
  RegisterWithPassword,
  Login,
  ResetPassword,
};
